export default "__VITE_ASSET__pLS35WHm__"